const order = (request, api_config) => {
  const prefix = "Order";

  const GetOrderListFilter = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetOrderListFilter`,
      method: "get",
      params: data,
    });
    return result;
  };

  const GetOrderList = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetOrderList`,
      method: "post",
      data: data,
    });
    return result;
  };

  const CreateOrder = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/CreateOrder`,
      method: "post",
      data: data,
    });
    return result;
  };

  const CreateOrderInvoice = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/CreateOrderInvoice`,
      method: "post",
      data: data,
    });
    return result;
  };

  const BeforeCreateOrderV2 = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/BeforeCreateOrderV2`,
      method: "post",
      data: data,
    });
    return result;
  };

  const WeChatOrder = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/WeChatOrder`,
      method: "post",
      data: data,
    });
    return result;
  };

  return {
    GetOrderListFilter,
    GetOrderList,
    CreateOrder,
    CreateOrderInvoice,
    BeforeCreateOrderV2,
    WeChatOrder,
  };
};

export default order;
